import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { css } from '@linaria/core'
import InfoCard from '../info-card/PersonInfoCard'
import Ruler from './components/Ruler'
import FamilyChips from './components/FamilyChips'
import TimelineItem from './components/TimelineItem'
import TimelineGrid from './components/TimelineGrid'

import { getTotalStartEndYear, getYearStepSize, getRoundedHighLow } from './timeline-helpers'

const timelineContentCss = css`
  overflow: overlay;
  padding: 0 24px 24px 24px;
`

export default function FamilyTimelineCard({ timelineItems, ...props }) {
  const [t] = useTranslation()
  const defaultChip = timelineItems?.spouseFamily ? 'spouse-and-children' : 'parents-and-siblings'
  const [selectedChip, setSelectedChip] = useState(defaultChip)

  const family = selectedChip === 'spouse-and-children' ? timelineItems?.spouseFamily : timelineItems?.parentFamily

  // Create Start/End Years on Each Item
  const { totalStartYear, totalEndYear } = getTotalStartEndYear(family)

  const [maxMarkers, setMaxMarkers] = useState(0)
  const yearStepSize = getYearStepSize(totalStartYear, totalEndYear, maxMarkers)
  const { roundedLow, roundedHigh } = getRoundedHighLow(totalStartYear, totalEndYear, yearStepSize)

  const onSelectionChange = (newChip) => {
    setSelectedChip(newChip.value)
  }

  return (
    <InfoCard heading={t('info-cards.family-timeline.header')} {...props}>
      <FamilyChips
        selectedChip={selectedChip}
        onSelectionChange={onSelectionChange}
        spouseFamily={timelineItems?.spouseFamily}
        parentFamily={timelineItems?.parentFamily}
      />
      <div className={timelineContentCss}>
        <Ruler
          lowYear={roundedLow}
          highYear={roundedHigh}
          setMaxMarkers={setMaxMarkers}
          maxMarkers={maxMarkers}
          yearStepSize={yearStepSize}
        />

        <TimelineGrid lowYear={roundedLow} highYear={roundedHigh}>
          {family?.map((timelineItem, index) => {
            const { start, end, id, type, focusItem, personData, eventData } = timelineItem
            const key = `${id}-${type}`
            return (
              <TimelineItem
                key={key}
                type={type}
                row={index + 1}
                startYear={start}
                endYear={end}
                totalStartYear={roundedLow}
                name={personData?.name}
                gender={personData?.gender?.toLowerCase()}
                lifespan={personData?.lifespan}
                date={eventData?.details?.date?.localizedText}
                focusItem={focusItem}
              />
            )
          })}
        </TimelineGrid>
      </div>
    </InfoCard>
  )
}

// Stryker disable all
FamilyTimelineCard.propTypes = {
  /** Items to display in the timeline including parents and spouse families */
  timelineItems: PropTypes.shape({}),
}
